/* eslint-disable react/jsx-props-no-spreading, no-undef */
import {yupResolver} from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
import React from 'react';
import {Controller, useForm} from 'react-hook-form';
import {useDispatch} from 'react-redux';
import * as yup from 'yup';
import Form from '../../components/Form/Form';
import FormActions from '../../components/FormActions/FormActions';
import FormField from '../../components/FormField/FormField';
import Button from '../../components/UI/Button/Button';
import InputDate from '../../components/UI/InputDate/InputDate';
import InputTypePrice from '../../components/UI/InputTypeText/InputTypePrice';
import InputTypeText from '../../components/UI/InputTypeText/InputTypeText';
import SelectCustomer from '../../components/UI/SelectCustomer/SelectCustomer';
import {formatDecimalNumber} from '../../helpers/helpers';
import {dateToTimestamp} from '../../helpers/utils';
import useReduxForm from '../../hooks/useReduxForm';
import {realityCreate} from '../../store/actions/index';

// Constraints.
const constraints = yup.object().shape({
  reference_id: yup.number().positive().integer().required('Je nutné vybrat dodavatele.'),
});

const ProjectCostsItemItemCreateForm = ({projectId, onSubmit}) => {
  const dispatch = useDispatch();
  const {loading, submitErrors} = useReduxForm(onSubmit);

  const date = new Date();

  // Default values.
  const defaultValues = {
    reference_id: null,
    description: '',
    quantity: 0,
    unit: 'items',
    buyPrice: 0,
    sellPrice: 0,
    bought_at: date,
  };

  const {
    control,
    handleSubmit,
    getValues,
    watch,
    formState: {errors},
  } = useForm({
    defaultValues,
    resolver: yupResolver(constraints),
  });

  // Handle submit.
  const handleFormSubmit = data => {
    const payload = {};
    payload.project = projectId;
    payload.plan = 0;
    payload.referenceId = data.reference_id || null;
    payload.description = data.description || '';
    payload.quantity = data.quantity || 0;
    payload.unit = data.unit || 'items';
    payload.buyPrice = data.buyPrice ? parseFloat(data.buyPrice) : 0;
    payload.sellPrice = data.sellPrice ? parseFloat(data.sellPrice) : 0;
    if (data.bought_at) {
      payload.boughtAt = dateToTimestamp(data.bought_at);
    }

    dispatch(
      realityCreate(
        payload.project,
        payload.plan,
        payload.referenceId,
        payload.description,
        payload.quantity,
        payload.unit,
        payload.buyPrice,
        payload.sellPrice,
        payload.boughtAt
      )
    );
  };

  // Render component.
  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <Form loading={loading} errors={submitErrors}>
        <FormField label='Dodavatel' errors={errors.reference_id?.message}>
          <Controller
            name='reference_id'
            control={control}
            value={getValues('reference_id')}
            render={({field}) => <SelectCustomer {...field} />}
          />
        </FormField>
        <FormField label='Krátký popis' errors={errors.description?.message}>
          <Controller
            name='description'
            control={control}
            value={getValues('description')}
            render={({field}) => <InputTypeText {...field} />}
          />
        </FormField>
        <FormField label='Kusů' errors={errors.quantity?.message}>
          <Controller
            name='quantity'
            control={control}
            value={getValues('quantity')}
            render={({field}) => <InputTypeText {...field} />}
          />
        </FormField>
        <div className='field__group'>
          <FormField label='Cena nákupu za jednotku' errors={errors.buyPrice?.message}>
            <Controller
              name='buyPrice'
              control={control}
              value={getValues('buyPrice')}
              render={({field}) => <InputTypePrice {...field} />}
            />
          </FormField>
          <FormField label='Cena nákupu celkem'>
            {formatDecimalNumber((watch('buyPrice') || 0) * watch('quantity'))}
          </FormField>
        </div>
        <div className='field__group'>
          <FormField label='Cena prodeje za jednotku' errors={errors.sellPrice?.message}>
            <Controller
              name='sellPrice'
              control={control}
              value={getValues('sellPrice')}
              render={({field}) => <InputTypePrice {...field} />}
            />
          </FormField>
          <FormField label='Cena prodeje celkem'>
            {formatDecimalNumber((watch('sellPrice') || 0) * watch('quantity'))}
          </FormField>
        </div>
        <FormField label='Datum nákupu' className='time-day' errors={errors.bought_at?.message}>
          <Controller
            name='bought_at'
            control={control}
            value={getValues('bought_at')}
            render={({field}) => <InputDate {...field} />}
          />
        </FormField>
        <FormActions>
          <Button value='Vytvořit' type='submit' width='full' />
        </FormActions>
      </Form>
    </form>
  );
};

export default ProjectCostsItemItemCreateForm;

ProjectCostsItemItemCreateForm.defaultProps = {
  projectId: null,
};

ProjectCostsItemItemCreateForm.propTypes = {
  projectId: PropTypes.number,
  onSubmit: PropTypes.func.isRequired,
};
